export const GENERAL = 'general';
export const ENUMERATION = 'enumeration';
export const BUILD_YOUR_OWN = 'advanced';
